import { render, staticRenderFns } from "./GestionCita.vue?vue&type=template&id=5f5bc447&scoped=true"
import script from "./GestionCita.vue?vue&type=script&lang=js"
export * from "./GestionCita.vue?vue&type=script&lang=js"
import style0 from "./GestionCita.vue?vue&type=style&index=0&id=5f5bc447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5bc447",
  null
  
)

export default component.exports